import axios from "axios";

export const apiCallWrapper = async (url = "", params = {}, type = "get") => {
  try {
    if (type === "get") {
      let urlWithParams = url;
      if (Object.values(params).length > 0) {
        urlWithParams = `${urlWithParams}?${Object.keys(params)
          // @ts-ignore
          .map((key) => `${key}=${params[key]}`)
          .join("&")}`;
      }
      const { data } = await axios.get(urlWithParams);
      return data;
    }
    if (type === "post") {
      const { data } = await axios.post(url, params);
      return data;
    }
  } catch (e: any) {
    console.error(
      `Error API call:`,
      e.message,
      e.config?.method,
      e.config?.url,
    );
  }
  return null;
};
